export default {"src":"/_next/static/media/0x6f40d4A6237C257fff2dB00FA0510DeEECd303eb.168a8a5a.svg","height":1386,"width":1393,"blurWidth":0,"blurHeight":0};